export default {"src":"/_next/static/media/confetti.b6708806.gif","height":699,"width":689,"blurWidth":0,"blurHeight":0};